var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.182,
    height: 16.152,
    viewBox: "0 0 16.182 16.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.985 -2.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49807",
    "data-name": "Path 49807",
    d: "M14.693,13.9l-1.79-1.79a3.442,3.442,0,0,0,0-4.009l1.787-1.787a2.306,2.306,0,0,0,2.8-3.617,2.364,2.364,0,0,0-3.267,0,2.285,2.285,0,0,0-.351,2.8L12.086,7.282a3.442,3.442,0,0,0-4.009,0L6.288,5.493a2.285,2.285,0,0,0-.351-2.8,2.364,2.364,0,0,0-3.267,0,2.3,2.3,0,0,0,2.8,3.617L7.258,8.1a3.442,3.442,0,0,0,0,4.009L5.468,13.9a2.368,2.368,0,0,0-2.8.347,2.317,2.317,0,1,0,3.616.467l1.787-1.787a3.442,3.442,0,0,0,4.009,0l1.787,1.787a2.305,2.305,0,1,0,3.617-.466,2.368,2.368,0,0,0-2.8-.346Z",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsCardIcon);
export default __webpack_public_path__ + "static/media/channelsCardIcon.5251033e57f073b31ae063c611d2615a.svg";
export { ForwardRef as ReactComponent };